export let locStor = {
  saveEmployees(employees) {
    localStorage.employees = JSON.stringify(employees);
  },
  getEmployees() {
    return localStorage.employees ? JSON.parse(localStorage.employees) : [];
  },
  saveProducts(products) {
    localStorage.products = JSON.stringify(products);
  },
  getProducts() {
    return localStorage.products ? JSON.parse(localStorage.products) : [];
  },
  saveCompanyHistory(companyHistory) {
    localStorage.companyHistory = JSON.stringify(companyHistory);
  },
  getCompanyHistory() {
    return JSON.parse(localStorage.companyHistory);
  },
  saveLegal(legal) {
    localStorage.legal = JSON.stringify(legal);
  },
  getLegal() {
    return JSON.parse(localStorage.legal);
  },
  saveLastFetched(lastFetched) {
    localStorage.lastFetched = lastFetched;
  },
  getLastFetched() {
    return localStorage.lastFetched;
  },
  saveTypes(types) {
    localStorage.types = JSON.stringify(types);
  },
  getTypes() {
    return localStorage.types ? JSON.parse(localStorage.types) : [];
  },
};



// WEBPACK FOOTER //
// ./src/localStorageManagement.js